import React from "react";

import { toggles } from "@src/dependencies";

export const AppContext = React.createContext({});

export default ({ children }) => {
  const contextValue = {
    isVRCustomizationEnabled: toggles.vrCustomizationEnabled,
  };

  return (
    <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>
  );
};
